import React from 'react';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AUTH_GA_LIBRE_GET_BANKS_INFO, AUTH_GA_LIBRE_SAVE_BANK } from 'apps/auth/constants/UrlConstants';

const HaveBankAccount = (props) => {
    const onClickDontHave = (e) => {
        props.doRequest(e, AUTH_GA_LIBRE_SAVE_BANK);
    };

    const onClickHave = (e) => {
        props.doRequest(e, AUTH_GA_LIBRE_GET_BANKS_INFO);
    };

    return (
        <>
            <HeaderPanel title={props.messages.haveBankAccountTitle} />
            <Row indent="adaptive-24-32">
                <Panel isBordered hasBorderRadius isHoverable onClick={onClickDontHave}>
                    <Text>{props.messages.dontHaveBankAccountText}</Text>
                </Panel>
            </Row>
            <Panel isBordered hasBorderRadius isHoverable onClick={onClickHave}>
                <Text>{props.messages.haveBankAccountText}</Text>
            </Panel>
        </>
    );
};
export default HaveBankAccount;
